export default __webpack_public_path__ + "95a96075fddec7910f93ced34f549416.png";